class TextColumnsCarousel {
  constructor(container) {
    this.container = container;
    this.viewport = container.querySelector(".text-columns-with-images__carousel-viewport");
    this.slider = container.querySelector(".text-columns-with-images__carousel-slider");
    this.slides = container.querySelectorAll(".text-columns-with-images__carousel-slide");
    this.prevBtn = container.querySelector(".text-columns-with-images__carousel-nav--prev");
    this.nextBtn = container.querySelector(".text-columns-with-images__carousel-nav--next");
    this.dots = container.querySelectorAll(".text-columns-with-images__carousel-dot");
    this.currentIndex = 0;
    this.totalSlides = this.slides.length;
    this.isAnimating = false;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.hasHorizontalIntent = false;
    this.init();
  }

  init() {
    if (this.totalSlides <= 1) {
      this.hideNavigation();
      return;
    }
    this.setupEventListeners();
    this.updateNavigation();
    this.updateDots();
    this.setupTouchEvents();
  }

  setupEventListeners() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener("click", () => this.prev());
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener("click", () => this.next());
    }
    this.dots.forEach((dot, index) => {
      dot.addEventListener("click", () => this.goToSlide(index));
    });
    this.container.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") {
        this.prev();
      } else if (e.key === "ArrowRight") {
        this.next();
      }
    });
    window.addEventListener("resize", () => {
      this.updateSliderPosition();
    });
  }

  setupTouchEvents() {
    if (!this.viewport) return;

    this.viewport.addEventListener(
      "touchstart",
      (e) => {
        const touch = e.touches[0];
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
        this.touchEndX = touch.clientX;
        this.hasHorizontalIntent = false;
      },
      { passive: true }
    );

    this.viewport.addEventListener(
      "touchmove",
      (e) => {
        if (!e.touches || e.touches.length === 0) return;

        const touch = e.touches[0];
        const deltaX = touch.clientX - this.touchStartX;
        const deltaY = touch.clientY - this.touchStartY;

        if (!this.hasHorizontalIntent) {
          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
            this.hasHorizontalIntent = true;
          } else if (Math.abs(deltaY) > 10) {
            // 用户明确是纵向滑动，直接允许默认滚动
            return;
          }
        }

        if (this.hasHorizontalIntent) {
          e.preventDefault();
          this.touchEndX = touch.clientX;
        }
      },
      { passive: false }
    );

    this.viewport.addEventListener(
      "touchend",
      (e) => {
        if (!this.hasHorizontalIntent) return;

        const touch = e.changedTouches[0];
        this.touchEndX = touch.clientX;
        this.handleSwipe();
      },
      { passive: true }
    );
  }

  handleSwipe() {
    const diff = this.touchStartX - this.touchEndX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? this.next() : this.prev();
    }
  }

  prev() {
    if (this.isAnimating) return;
    const newIndex = this.currentIndex - 1;
    if (newIndex >= 0) {
      this.goToSlide(newIndex);
    }
  }

  next() {
    if (this.isAnimating) return;
    const newIndex = this.currentIndex + 1;
    if (newIndex < this.totalSlides) {
      this.goToSlide(newIndex);
    }
  }

  goToSlide(index) {
    if (this.isAnimating || index < 0 || index >= this.totalSlides) return;

    this.isAnimating = true;
    this.currentIndex = index;
    this.updateSliderPosition();
    this.updateNavigation();
    this.updateDots();

    setTimeout(() => {
      this.isAnimating = false;
    }, 300);
  }

  updateSliderPosition() {
    if (!this.slider || !this.viewport) return;
    const slideWidth = this.viewport.offsetWidth;
    const translateX = -this.currentIndex * slideWidth;
    this.slider.style.transform = `translateX(${translateX}px)`;
  }

  updateNavigation() {
    if (!this.prevBtn || !this.nextBtn) return;
    this.prevBtn.disabled = this.currentIndex === 0;
    this.nextBtn.disabled = this.currentIndex === this.totalSlides - 1;
  }

  updateDots() {
    this.dots.forEach((dot, index) => {
      if (index === this.currentIndex) {
        dot.classList.add("active");
      } else {
        dot.classList.remove("active");
      }
    });
  }

  hideNavigation() {
    if (this.prevBtn) {
      this.prevBtn.style.display = "none";
    }
    if (this.nextBtn) {
      this.nextBtn.style.display = "none";
    }
    const dotsContainer = this.container.querySelector(".text-columns-with-images__carousel-dots");
    if (dotsContainer) {
      dotsContainer.style.display = "none";
    }
  }

  startAutoPlay(interval = 5000) {
    this.stopAutoPlay();
    this.autoPlayInterval = setInterval(() => {
      if (this.currentIndex < this.totalSlides - 1) {
        this.next();
      } else {
        this.goToSlide(0);
      }
    }, interval);
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }

  destroy() {
    this.stopAutoPlay();
    if (this.prevBtn) {
      this.prevBtn.removeEventListener("click", this.prev);
    }
    if (this.nextBtn) {
      this.nextBtn.removeEventListener("click", this.next);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".text-columns-with-images__grid--mobile-carousel").forEach((container) => {
    new TextColumnsCarousel(container);
  });
});

if (typeof module < "u" && module.exports) {
  module.exports = TextColumnsCarousel;
}